import React, { Component } from 'react'
import http from '../../../http'
import FadeCheck from '../../../components/FadeCheck'
import buildIcon from '../../../helpers/buildIcon'

import {
  FiMenu
} from 'react-icons/fi'

class Aside extends Component {
  state = {
    aside: []
  }

  componentDidMount() {
    http
      .get( '/api/collection/aside/all' )
      .then( response => {
        console.debug( 'aside', response.data )
        this.setState( ( state, props ) => ( {
          ...state,
          aside: response.data
        } ) )
      } )
  }

  update( path, checked ) {
    const { collection, update: _update } = this.props

    const index = collection.indexOf( path )
    if ( checked ) {
      if ( index === -1 )
        collection.push( path )
    } else {
      if ( index !== -1 )
        collection.splice( index, 1 )
    }

    _update( collection )
  }

  render() {
    const it = this
    const { collection } = this.props

    const aside = this.state.aside
      .map( ( el, i ) => {
        const { identity, label: title, icon } = el
        const Icon = buildIcon( icon )
        const checked = collection.indexOf( identity ) !== -1

        return (
          <div className="one hs centered card padding relative" key={ i }>
            <Icon className="text x5" />

            <label className="text centered">{ title }</label>

            <FadeCheck
              initialValue={ checked }
              update={ ( checked ) => it.update( identity, checked ) }
            />
          </div>
        )
      } )

    return (
      <>
        <div className="title">
          <FiMenu />
          <h1>menu lateral</h1>
        </div>

        <div className="vs padding">
          { aside }
        </div>
      </>
    )
  }
}

export default Aside
